import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {QueryDataSource} from '@github-ui/react-core/future/data-router-types'
import {ssrSafeDocument, wasServerRendered} from '@github-ui/ssr-utils'
import {sendCustomMetric} from '@github-ui/stats'

const CACHE_RESULTS = {ssr: 'ssr', cache: 'hit-hot', idb: 'hit', network: 'miss'} as const

let listenerRegistered = false
let pendingLoad:
  | {
      request: Request
      source?: QueryDataSource
      event?: CustomEvent<PlatformBrowserPerformanceWebVitalTiming>
    }
  | undefined

export function initIssueViewerHPC() {
  if (listenerRegistered || !ssrSafeDocument) return
  listenerRegistered = true
  ssrSafeDocument.addEventListener('web-vitals:hpc', event => {
    if (
      !pendingLoad ||
      pendingLoad.request.signal.aborted ||
      !(event instanceof CustomEvent) ||
      typeof event.detail?.hpc !== 'number' ||
      event.detail.name?.split('#', 1)[0] !== pendingLoad.request.url.split('#', 1)[0]
    ) {
      return
    }
    pendingLoad.event ??= event
    reportIfReady()
  })
}

export function observeIssueViewerFirstData(request: Request): (source: QueryDataSource) => void {
  const load: NonNullable<typeof pendingLoad> = {request}
  pendingLoad = load
  return source => {
    if (pendingLoad !== load || request.signal.aborted) return
    load.source ??= source
    reportIfReady()
  }
}

function reportIfReady() {
  if (!pendingLoad?.source || !pendingLoad.event || pendingLoad.request.signal.aborted) return
  const {source, event} = pendingLoad
  const hpc = event.detail.hpc
  if (typeof hpc !== 'number') return

  pendingLoad = undefined
  sendCustomMetric(
    {
      name: 'ISSUES_SHOW_HPC',
      value: hpc,
      tags: {
        cpu: event.detail.cpu || 'unknown',
        cache_result: CACHE_RESULTS[source],
        mechanism: event.detail.mechanism || 'unknown',
        ssr: wasServerRendered() ? 'true' : 'false',
        did_load_global_required_bundles_after_react: isFeatureEnabled('defer_required_bundles_after_react')
          ? 'true'
          : 'false',
        page: 'issue-show',
      },
    },
    undefined,
    1,
  )
}
